import {post,get} from '../libs/ajax.js'

export default {
    // 角色列表
    getDataList: (data, options) => {
        return post('/plat_company/list', data, options)
    },

    // 查看运营历史
    getYYHistory:(data,options)=>{
        return get('/plat_company/yy_operation_list', data, options)
    },
    // 获取运营用户列表 - 授权或设置运营时使用 参数：type 1-运营负责人 2-授权
    getYYUserList:(data,options)=>{
        return get('/plat_company/yy_list', data, options)
    },
    // 设置运营负责人
    setYY:(data,options)=>{
        return post('/plat_company/set_yy', data, options)
    },
    // 删除运营分配记录
    deleteYYLog:(data,options)=>{
        return post('/plat_company/del_yy_operation_log', data, options)
    },
    // 授权
    accountAuth:(data,options)=>{
        return post('/plat_company/authorize', data, options)
    },
    // 批量授权
    accountBatchAuth:(data,options)=>{
        return post('/plat_company/batch_authorize', data, options)
    },
    // 获取部门信息 - 媒体账户绑定列表页使用
    getPlatCompanySearchList:(data,options)=>{
        return get('/plat_company/search_list', data, options)
    },

    // 媒体账户绑定列表-筛选条件：获取账户列表 search batch_search
    getAccountOptionList:(data,options)=>{
        return post('/plat_company/get_account_search_list', data, options)
    },
    // 媒体账户绑定列表-筛选条件：获取客户列表
    getCustomerOptionList:(data,options)=>{
        return post('/plat_company/get_customer_search_list', data, options)
    },
    // 媒体账户绑定列表-筛选条件：获取集团列表
    getBlocOptionList:(data,options)=>{
        return post('/plat_company/get_bloc_search_list', data, options)
    },
}
